import { Action, ActionReducer, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMap from './map.reducer';

export const featureKey = 'iotPlatformMaps';

export interface MapsState {
  [fromMap.featureKey]: fromMap.State;
}

export interface State {
  [featureKey]: MapsState;
}

export const selectState = createFeatureSelector<MapsState>(featureKey);
export const selectMapState = createSelector(selectState, (state: MapsState) => state[fromMap.featureKey]);

export function reducers(state: MapsState, action: Action): ActionReducer<MapsState> {
  return combineReducers({
    [fromMap.featureKey]: fromMap.reducer
  })(state, action) as unknown as ActionReducer<MapsState>;
}

export const mapUiState = createSelector(selectMapState, (state: fromMap.State) => state.mapUiState);
